import { useEffect } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const Recaptcha = ({ onVerify, actionName, setExecuteRecaptcha }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    if (!executeRecaptcha) return;

    // Store function for later execution
    setExecuteRecaptcha(() => executeRecaptcha);

    // Get a reCAPTCHA token immediately on mount
    executeRecaptcha(actionName || "register")
      .then(onVerify)
      .catch((error) => console.error("reCAPTCHA error:", error));
  }, [executeRecaptcha]); // Dependency on executeRecaptcha

  return null;
};

export default Recaptcha;
